import { render, staticRenderFns } from "./ChoosePredictionsStep.vue?vue&type=template&id=60cce20e&"
import script from "./ChoosePredictionsStep.vue?vue&type=script&lang=js&"
export * from "./ChoosePredictionsStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports